<template>
  <div class="mw-panel inner-query-roles">
    <mw-dialog title="角色选择" size="mini_mini" :footerButton="btns" ref="addRolesDialog" :close-on-click-modal="false">
      <mw-tree :url="codeRoleTreeUrl" :multipleLeaf="true"
               :async="false" :expandedFirst="true" :defaultParams="treeDefaultParams"
               ref="codeRoleTree" :multiple="true"></mw-tree>
    </mw-dialog>
    <mw-dialog size="large_large"  title="选择用户" ref="userDialog" :footerButton="userFooterButton" :close-on-click-modal="false">
      <loadMan ref="userChoose" :defaultParentId="defaultParentId" :listAble="listAble" :isAppendDepartment="true" :isRadio="true"></loadMan>
    </mw-dialog>
    <div class="mw-toolbar"   v-show="(userInfo.ownerAdmin||userInfo.unitAdmin || !userInf[0].isLimit) && !noResetPwd"> <!--noResetPwd是为了不增加参数的情况下控制此按钮三员下的显示 -hyg-->
      <!-- userInfo.ownerAdmin||userInfo.unitAdmin || !userInf[0].isLimit -->
      <el-button @click="checkRoles" type="primary" >添加</el-button>
      <el-button @click="deleteRoles">删除</el-button>
      <el-button @click="copyJobRoles" >复制</el-button>
    </div>
    <div class="mw-toolbar__body">

      <el-col :span="12">
        <mw-tree :multiple="false" :multipleLeaf="true"
                  :treeData="treeData" :url="deptRoleTreeUrl" :autoLoad="false"
                 ref="deptRoleTree" @changed="changed" :selectNode="selectNode">
        </mw-tree>
      </el-col>

      <el-col :span="12">
        <template>
          <el-table
            :data="limitName"
            stripe
            style="width: 100%">
            <el-table-column
              label="权限名称">
              <template slot-scope="scope">
                {{scope.row.name}}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-col>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import loadMan from "./loadManager.vue"
export default {
  components: {
    loadMan,
  },
  props: {
    userIdentityId: {
      type: String,
      default: ""
    },
    deptId: {
      type: String,
      default: ""
    },
    userInf:{
      type: Array,
      default: function(){
        return []
      }
    },
    listAble:{
      type: Boolean,
      default: false
    },
    noResetPwd:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deptRoleTreeUrl: "/api/org/listDepartmentUserGroup",
      codeRoleTreeUrl: "/api/org/getGroupTree",
      addRolesVisible: false,
      defaultParentId:'',
      unitId: "",
      total: 0,
      checkRoleIds: [],
      selectNode: "",
      roleData: [],
      treeData: [],
      limitName: [],
      treeDefaultParams:{},
      userFooterButton: [
        { label: '确定', func: this.chooseUserSure },
        { label: '取消', func: this.cancelChooseUser, type: 'default' }
      ],
      btns: [
        {
          label: "取消",
          func: this.cancelAddRoles,
          type: "default"
        },
        {
          label: "确定",
          func: this.addRolesSure
        }
      ]
    };
  },

  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },

  mounted() {
    this.getTreeData(true);
  },

  methods: {
    changed(data) {
      let me = this;
      if(data.id == '身份权限'||data.id == '文档权限'||data.id == '流程权限'){
        var type = "";
        if(data.id == '身份权限'){
          type="1";
        }else if(data.id == '文档权限'){
          type="2";
        }else if(data.id == '流程权限'){
          type="3";
        }
        this.mwApi.org.listDepartmentUserRoleByType(this.userIdentityId,type).then(res => {
          me.limitName = res.result;
        });
      }else if(data.id == '查看全部权限') {
        //me.limitName = [];getDepartmentTypeIdentity
        this.mwApi.org.listDepartmentUserRole(this.userIdentityId,'').then(res => {
          me.limitName = res.result;
        });
      } else {
         me.mwApi.org.getGroup(data.id).then(res => {
          let limitName = [];
          if(res.result.roleNames){
          let names = res.result.roleNames.split(",");
          let roleIds = res.result.roleIds.split(",");
          names.forEach((d, index) => {
            limitName.push({
              id: roleIds[index],
              name: d
            });
          });
          me.limitName = limitName;
          }
        });
      }
    },

    //加载对话框左边的树的数据
    getTreeData(a) {
      this.roleData = [];
      this.treeData = [];
      this.selectNode = "";
      this.mwApi.org.listDepartmentUserGroup(this.userIdentityId).then(data => {
        data.result.forEach(d => {
          this.roleData.push({
            id: d.id,
            text: d.name
          });
        });

        this.treeData.push(
          {
            text: "角色",
            children: this.roleData,
            state: {
              disabled: true,
              opened : true
            }
          },
          {
            text: "查看全部权限",
            children: [{text:"身份权限"},{text:"文档权限"},{text:"流程权限"}],
            state: {
              disabled: false,
              opened : true
            }
          }
        );

        if (!a) {
          this.mwRef("deptRoleTree").refreshData(this.treeData);
          this.mwRef("deptRoleTree").openAll();
        } else {
          // this.mwRef("deptRoleTree").renderTree();
           this.mwRef("deptRoleTree").openAll();
        }
        if (this.roleData.length != 0) {
          this.selectNode = this.roleData[0].id;
        } else {
          this.limitName = [];
        }
    });
    },

    // 添加权限组
    checkRoles() {
      this.mwApi.org.getUnitById(this.deptId).then(res => {
        this.unitId = res.result.id;
        this.treeDefaultParams.unitId = this.unitId;
        this.checkRoleIds = [];
        this.mwRef("addRolesDialog").show();
        if (this.total != 0) {
          this.mwRef("codeRoleTree").refresh();
        }
        this.total = 1;

        this.roleData.forEach(d => {
          this.checkRoleIds.push(d.id);
        });
      });
    },

    addRolesSure() {
      let a = false;
      let groupIds = [],groups=[];
      this.mwRef("codeRoleTree")
        .getSelected()
        .forEach(d => {
          if (this.checkRoleIds.indexOf(d.id) != -1) {
            a = true;
            this.mwMsg("warning", "该" + d.text + "已存在无需重复添加");
            return;
          } else {
            groupIds.push(d.id);
            groups.push(d);
            a = false;
          }
        });

      if (!a) {
        if (groupIds.length != 0) {
          this.mwApi.org
            .addDepartmentUserGroup(this.userIdentityId, groupIds)
            .then(res => {
              if (res.success) {
                this.getTreeData(false);
                groups.forEach( g =>{
                   let params =g;
                   if(g.userNames){
                    params.userNames = params.userNames+','+this.userInf[0].name;
                    params.userDeptIdentityIds = params.userDeptIdentityIds +','+this.userInf[0].id;
                    params.departmentIds = params.departmentIds +','+this.userInf[0].departmentId;}
                   else{
                    params.userNames = this.userInf[0].name;
                    params.userDeptIdentityIds =this.userIdentityId;
                    params.departmentIds =this.userInf[0].departmentId;
                   }
                   this.mwApi.org.saveGroup(g)
                })

              }
            });
        }
        this.mwRef("addRolesDialog").hide();
      }
    },

    deleteRoles() {
      let data = this.mwRef("deptRoleTree").getSelected();
      if(["查看全部权限","身份权限","文档权限","流程权限"].indexOf(data.id) != -1){
        this.mwMsg("请选择角色");
        return;
      }
      if (data.id && data.id != "1") {
        this.$confirm('您确定要删除此角色?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          this.mwApi.org
            .deleteDepartmentUserGroup(this.userIdentityId, data.id)
            .then(res => {
              if (res.success) {
                this.mwMsg("删除成功");
                this.getTreeData(false);
                // this.mwApi.org.getGroup(data.id).then( d =>{
                //   if(d.result && d.success){
                //     let departmentIds =[],userNames=[],userDeptIdentityIds=[];
                //     if(d.result.userNames){
                //       userNames = d.result.userNames.split(',');
                //     }
                //     if(d.result.departmentIds){
                //       departmentIds = d.result.departmentIds.split(',');
                //     }
                //     userNames.forEach((u,index) =>{
                //       if(u === this.userInf[0].name){
                //         userNames.splice(index,1);
                //         departmentIds.splice(index,1);
                //       }
                //     })
                //     let params =d.result;
                //     params.userNames = userNames.join();
                //     params.departmentIds = departmentIds.join();
                //     this.mwApi.org.saveGroup(params)
                //   }
                // })

              } else {
                this.mwMsg("info", "删除失败");
              }
            });
          }).catch(() => {})
      }
    },
    copyJobRoles(){
      let me = this;
      if(!me.roleData || me.roleData.length == 0){
        PF.message("没有角色，不用复制");
        return;
      }
      this.mwApi.org.getUnitById(this.deptId).then(res => {
        me.defaultParentId = res.result.id;
        me.$refs.userDialog.show();
      });
    },
    chooseUserSure() {
      let data = this.mwRef('userChoose').getValue();
      this.mwRef('userDialog').hide();
      let p = [];
      data.forEach(d => {
        p.push({id:d.id,name:d.name,identity:d.identityId,departmentId:d.departmentId});
      });
      let groupIds = [];
      _.each(this.roleData,function(g){
        groupIds.push(g.id);
      })
      PF.invoke("#api/org/copyUserJobRoles",{us:p,groupIds:groupIds}).then(function(res){
        if(res && res.result){
          PF.message("复制成功")
        }
      })
    },
    cancelChooseUser() {
      this.mwRef('userDialog').hide();
    },
    cancelAddRoles() {
      this.mwRef("addRolesDialog").hide();
    }
  },

  watch: {
    userIdentityId: function(val) {
      this.getTreeData(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/queryRoles.vue